import LandingPage from '../pages/landing/LandingPage';

import AboutPage from '../pages/about/AboutPage';

import ProjectsPage from '../pages/project/ProjectsPage';
import SingleProjectPage from '../pages/project/SingleProjectPage';

import StoriesPage from '../pages/story/StoriesPage';
import SingleStoryPage from '../pages/story/SingleStoryPage';

import ErrorPage from '../pages/error/ErrorPage';

export const routes  = [
  {
    path: '/',
    element: <LandingPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/projects',
    element: <ProjectsPage />,
  },
  {
    path: '/work/:title',
    element: <SingleProjectPage />,
  },
  {
    path: '/stories',
    element: <StoriesPage />,
  },
  {
    path: '/blog/:title',
    element: <SingleStoryPage />,
  },
  {
    path: '*',
    element: <ErrorPage />,
  },
];